<template>
    <div class="swiper-outer">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" :key="item.saleUserId" v-for="item in dataList">
                    <div class="title-box">
                        <span class="avatar">{{ item.saleUserName.slice(0, 1) }}</span>
                        <span>{{ item.saleUserName }}</span>
                    </div>
                    <div class="target-rate">
                        <el-progress type="circle" :percentage="item.rate" :stroke-width="10" :width="140"></el-progress>
                        <label>目标达成率</label>
                    </div>
                    <el-row :gutter="10" class="sideways-box">
                        <el-col :span="12" class="price-item">
                            <label>目标金额</label>
                            <span class="value">{{ item.targetPrice}}<i class="unit">万元</i></span>
                        </el-col>
                        <el-col :span="12" class="price-item">
                            <label>合同金额</label>
                            <span class="value">{{ item.contractPrice }}<i class="unit">万元</i></span>
                        </el-col>
                    </el-row>
                    <el-row class="split-box">
                        <el-col :span="12">
                            <div class="price-total" @click="openInvoice(item.saleUserId)">
                                <img src="~@/assets/image/statistics/icon-receive-full.png">
                                <label>总到账金额</label>
                                <span class="value">{{ item.receivePrice}}<i class="unit">万元</i></span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="price-item" style="margin-bottom: 10px;">
                                <label>当年开票到账</label>
                                <span class="value">{{ item.thisYearReceivePrice}}<i class="unit">万元</i></span>
                            </div>
                            <div class="price-item">
                                <label>往年开票到账</label>
                                <span class="value">{{ item.beforeYearReceivePrice}}<i class="unit">万元</i></span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <div class="count-item" @click="openCovenant(item.saleUserId, '')">
                                <label>总客户数量</label>
                                <img src="~@/assets/image/statistics/icon-sale-count.png" alt="">
                                <span class="value">{{ item.customerCount }}</span>
                                <span class="unit">个</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="count-item" @click="openCovenant(item.saleUserId, 1)">
                                <label>新增客户数量</label>
                                <img src="~@/assets/image/statistics/icon-sale-new.png" alt="">
                                <span class="value">{{ item.newCustomerCount }}</span>
                                <span class="unit">个</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
    </div>
</template>

<script>
import Swiper, { Navigation, Pagination, Autoplay, Mousewheel, HashNavigation } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Mousewheel, HashNavigation]);
import 'swiper/swiper-bundle.css';
// import $ from "jquery";

export default {
    name: 'moduleSales',
    props: {
        dataList: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        dataList: {
            handler(val) {
                if (val && val.length) {
                    this.$nextTick(() => {
                        this.createCarousel();
                    })
                }
            },
            immediate: true,
            deep: true,
        }
    },
    data() {
        return {
            swiperInstance: null,
        }
    },
    methods: {
        // 构建轮播图dom
        createCarousel() {
            this.$nextTick(() => {
                this.swiperInstance = new Swiper(`.swiper-container`, {
                    direction: 'horizontal',
                    pagination: { // 分页器
                        el: `.swiper-pagination`,
                        clickable: true,
                    },
                    autoplay: false,
                    // autoplay: { // 自动播放
                    //     delay: 3000,
                    //     stopOnLastSlide: false,
                    //     disableOnInteraction: false, // 手动播放后继续自动播放
                    // },
                    slideToClickedSlide: true,
                    // loop: true,
                    navigation: {
                        nextEl: `.swiper-button-next`, // 右箭头
                        prevEl: `.swiper-button-prev` // 左箭头
                    },
                    slidesPerView: 3,
                    // spaceBetween: 15,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    on: {},
                })
                // 鼠标悬浮停止自动轮播
                // let _this = this;
                // $('.swiper-container').hover(() => {
                //     _this.swiperInstance.autoplay.stop();
                // }, function () {
                //     _this.swiperInstance.autoplay.start();
                // });
            })
        },
        // 点击打开合同详情弹窗
        openCovenant(saleUserId, contractType) {
            this.$emit('openCovenant', saleUserId, contractType)
        },
        // 点击打开开票详情弹窗
        openInvoice(saleUserId) {
            // 1-按到账统计
            this.$emit('openInvoice', saleUserId, 1)
        },
    }
}
</script>

<style lang="scss" scoped>
.swiper-outer {
    position: relative;
    height: 520px;
    // padding: 0 50px;
    .swiper-container {
        --swiper-theme-color: #409eff; /* 设置Swiper风格 */
        height: 100%;
        .swiper-wrapper {
            height: 100%;
            .swiper-slide {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 100%;
                padding: 20px 15px;
                border: 1px solid #ccc;
                border-radius: 15px;
                transform: scale(0.94);
                // &.swiper-slide-active {
                //     border-color: $primary-btn-color;
                // }
                .title-box {
                    display: flex;
                    align-items: center;
                    font-size: 18px;
                    font-weight: 600;
                    .avatar {
                        width: 30px;
                        height: 30px;
                        margin-right: 10px;
                        line-height: 29px;
                        text-align: center;
                        color: #fff;
                        background-color: #409eff;
                        font-size: 16px;
                        font-weight: 400;
                        border-radius: 50%;
                    }
                }
                .target-rate {
                    position: relative;
                    text-align: center;
                    label {
                        position: absolute;
                        bottom: 45px;
                        left: 50%;
                        transform: translateX(-50%);
                        color: #8e8e8e;
                        font-size: 15px;
                    }
                    /deep/ .el-progress .el-progress__text {
                        top: 43%;
                        color: $primary-font-color !important;
                        font-size: 22px !important;
                        font-weight: 600;
                    }
                }
                .split-box {
                    max-width: 100%;
                    padding: 12px 10px;
                    margin-bottom: 10px;
                    background-color: #f5f5fa;
                    border-radius: 6px;
                    .price-total {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        height: 100%;
                        cursor: pointer;
                        img {
                            width: 42px;
                            height: 42px;
                            box-sizing: border-box;
                            border-radius: 50%;
                        }
                        label {
                            margin-top: 6px;
                            margin-bottom: 2px;
                            color: #8e8e8e;
                            font-size: 14px;
                            cursor: inherit;
                        }
                        .value {
                            color: $primary-font-color;
                            font-size: 18px;
                            font-weight: 600;
                            .unit {
                                margin-left: 3px;
                                color: #8e8e8e;
                                font-size: 13px;
                                font-weight: 400;
                                font-style: normal;
                            }
                        }
                    }
                    .price-item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        color: #8e8e8e;
                        font-size: 14px;
                        .value {
                            margin-top: 3px;
                            color: #333;
                            font-size: 16px;
                            font-weight: 600;
                            .unit {
                                margin-left: 3px;
                                color: #8e8e8e;
                                font-size: 13px;
                                font-weight: 400;
                                font-style: normal;
                            }
                        }
                    }
                }
                .sideways-box {
                    .price-item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-bottom: 12px;
                        color: #8e8e8e;
                        font-size: 14px;
                        .value {
                            margin-top: 5px;
                            color: $primary-font-color;
                            font-size: 20px;
                            font-weight: 600;
                            .unit {
                                margin-left: 3px;
                                color: #8e8e8e;
                                font-size: 13px;
                                font-weight: 400;
                                font-style: normal;
                            }
                        }
                    }
                }
                .count-item {
                    display: flex;
                    flex-wrap: wrap;
                    width: 100%;
                    padding: 10px 15px !important;
                    color: #8e8e8e;
                    background-color: #f7f8fa;
                    border-radius: 6px;
                    font-size: 14px;
                    cursor: pointer;
                    label {
                        display: inline-block;
                        width: 100%;
                        margin-bottom: 6px;
                        white-space: nowrap;
                        cursor: inherit;
                    }
                    img {
                        width: 28px;
                        height: 28px;
                        margin-right: 10px;
                    }
                    .value {
                        color: $primary-font-color;
                        font-size: 18px;
                        font-weight: 600;
                    }
                    .unit {
                        padding-top: 2px;
                        padding-left: 4px;
                    }
                }
            }
        }
    }
    .swiper-pagination {
        left: 50%;
        bottom: -15px;
        transform: translateX(-50%);
    }
    .swiper-button-prev,
    .swiper-button-next {
        width: 50px;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 50%;
        transform: translateY(-30%);
    }
    .swiper-button-prev:after,
    .swiper-button-next:after {
        color: #fff;
        font-size: 24px;
    }
}
/deep/ .swiper-pagination-bullet {
    margin: 0 3px;
}
</style>